export class Pages {
  static ConsolidatedUsageList = "consolidated-usage-list"
  static CopyrightsAndTariffs = "copyrights"
  static Forbidden = "forbidden"
  static Login = "login"
  static MatchingStatistics = "matching-statistics"
  static PaymentFilesList = "payment-files"
  static NotFound = "not-found"
  static RepertoireFilesList = "repertoire-files-list"
  static RepertoireRecordingList = "repertoire-recordings-list"
  static RepertoireRecordingDetail = "repertoire-recording-detail"
  static RightsHoldersList = "rightsholders-list"
  static Stations = "stations"
  static UsagesFileList = "usages-file-list"
  static UsersList = "users-list"
  static UsersUpdate = "users-update"
  static UserRoles = "user-roles"
  static DistributionList = "distribution-list"
  static TransactionsList = "transactions-list"
  static RightsHolderPayees = "rights-holder-payees"
  static PayoutsList = "payouts-list"
  static HoldDetails = "hold-details"
  static TransactionsRemovalList = "transactions-removal-list"
  static FeesList = "fees-list"
  static CloseoutsList = "closeouts-list"
  static CloseoutsSnapshot = "closeouts-snapshot"
}
